module.exports = __webpack_public_path__ + "img/arrow.dfe15ff7.svg";